<template>
  <div>
    <div class="game" v-show="!reaction">


      <!-- ИНФОБЛОК -->
      <infoblock :active="active"></infoblock>

      <!-- ТЕЛО ТРЕНАЖЕРА -->
      <div class="game__body">


        <!--<countdown></countdown>-->
        <game_body :active="active" @onFinish="onFinish"></game_body>


        <div class="game__button" v-if="!start_game && !params.finish">
          <button class="uk-button uk-button-primary" @click="startGame()" v-if="!start_game">Начать!</button>
        </div>

        <div class="game__button" v-if="active">
          <button class="uk-button uk-button-primary" @click="stopGame">Закончить</button>
        </div>

      </div>


      <!-- ФИНИШ -->
      <finish v-if="params.finish" :scores="scores" @onStopGame="onStopTrainer" @onStartGame="startGame"></finish>


      <a href="#" @click.prevent="onStopTrainer">Остановить</a>
    </div>

    <!-- РЕАКЦИИ -->
    <!--<reaction></reaction>-->

  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { mix } from "./../mixin";
import { soundMix } from "../../../mixins/sound";
import countdown from "./modules/countdown";
import game_body from "./modules/game_body";
import infoblock from "./modules/infoblock";
import finish from "./modules/finish";
import axios from "axios";

export default {
  name: "game",
  inject: [
    'TrainerMethods', 'module_name', 'http'
  ],
  provide() {
    return {
      params: this.params
    }
  },
  mixins: [
    mix, soundMix
  ],
  data() {
    return {
      start_game: false,
      reaction: false,
      active: false,
      errors: 0,
      scores: 0
    }
  },
  components: {
    countdown, game_body, infoblock, finish
  },
  computed: {
    params() {
      return this.$store.state.train[this.module_name + '_params']
    },
    finish() {
      return this.params.finish
    },
    user() {
      return this.$store.state.user;
    },
  },
  methods: {

    beginApp() {
      this.scores = 0;
      this.params.finish = false;
      this.params.active = false;
    },

    startGame() {
      this.params.finish = false;
      this.active = true;
      this.start_game = true;
    },

    onFinish(time) {
      this.params.finish = true;
      this.params.active = false;
      this.addScores();
      //this.onStopTrainer();
      this.makeStats(time);
    },

    stopGame() {
      this.params.finish = true;
      this.active = false;
    },

    addScores() {
      console.log('add scores');
      let sum = 0;
      let scores = 2;
      sum = Math.ceil(scores);
      if (this.$route.params.isHomework) {
        sum = Math.ceil(sum * this.$store.state.hw_coefficient);
      }
      this.checkScoreStatus(sum);
      this.scores = sum;

      this.$store.commit('changeUserScores', sum);
      console.log('Баллов заработано', sum);
    },

    async makeStats(time) {
      console.log("Make stats");
      if (this.user.role.code !== 'student') return;
      console.log('Бережно сохраняем статистику');

      let train_params = this.params;
      let stats = {
        time: time,
        errors: 0,
        user_id: this.$store.state.user.id,
        trainer: this.$store.state.current_trainer.id,
        scores: 0,
        train_params: {
          bpm: train_params.bpm,
          has_accents: train_params.has_accents
        }
      }

      stats = this.checkHomework(stats);

      this.http.post('onSaveStats', { 'stat': stats }).then((res) => {
        this.checkCoins(res.data);
      });
    },


  },
  mounted() {
    this.beginApp();
  },
  beforeDestroy() {
    this.TrainerMethods.commitVal(false, 'start', this.module_name, this);
  }
}
</script>